import React, { Fragment } from 'react'
import {t} from 'i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Container, Row, Col, Button } from 'reactstrap'

import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb';
import { isNull } from '../../izUtils'
import AddUpdateFacility from '../../components/facilities/AddUpdateFacility';

const CreateFacility = () => {
    const Navigate = useNavigate();
    const { facilityId } = useParams();

    return (
        <Fragment>
            <Breadcrumbs parent={t('breadcrumb.allFacilities')} title={t('breadcrumb.createFacility')} />
            <Container fluid={true}>
                <Row>
                    <Col md="12">
                        {!isNull(facilityId) && <AddUpdateFacility />}
                    </Col>
                </Row>
                <hr/>
                <div className='mb-4'>
                    <Button color="danger" className="mt-2 me-2" onClick={() => Navigate('/facilities')}>{t('back')}</Button>
                </div>
            </Container>
        </Fragment>
    )
}

export default CreateFacility